module.exports = __webpack_public_path__ + "fonts/NouvelR-Bold.274fda0e.ttf";